var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 286,
    viewBox: "0 0 286 286",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M242.872 242.97H200.704V176.799C200.704 161.021 200.374 140.743 178.653 140.743C156.664 140.743 153.314 157.858 153.314 175.632V242.961H111.092V106.905H151.648V125.463H152.192C157.858 114.745 171.641 103.475 192.204 103.475C234.978 103.475 242.917 131.637 242.917 168.255V242.961L242.872 242.97ZM63.3909 88.3107C49.7861 88.3107 38.8809 77.3075 38.8809 63.7562C38.8809 50.2494 49.8307 39.264 63.3909 39.264C76.9511 39.264 87.9365 50.2494 87.9365 63.7562C87.9365 77.3075 76.9511 88.3107 63.3909 88.3107ZM84.542 242.97H42.2309V106.914H84.542V242.97ZM264.041 0H21.0263C9.41731 0 0 9.18566 0 20.5541V264.558C0 275.926 9.41731 285.112 21.0263 285.112H263.996C275.588 285.112 285.103 275.926 285.103 264.558V20.5541C285.103 9.18566 275.588 0 263.996 0L264.041 0Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon_linkedin.42978fe75e8dbcc51c5a922800a8f1a6.svg";
export { ForwardRef as ReactComponent };